// Numeric entry fields accept typing only.
//
// A native number input carries three ways to change a value without typing it:
// the spinner buttons, the mouse wheel while the field has focus, and the Up and
// Down keys. The spinner is easily confused with the page scroll, and a wheel
// event over a focused field silently rewrites an estimate the participant has
// already entered. Every numeric field in the study therefore hides the spinner
// and blocks both stepping paths, so the recorded value is always one the
// participant typed.
//
// The `type="number"` attribute stays, so the browser keeps enforcing min, max,
// and step, and mobile keyboards still open in numeric mode.

// Applied alongside each field's own classes. The rule lives in index.css.
export const NO_SPINNER_CLASS = "number-arrows-none";

const STEPPING_KEYS = new Set([
  "ArrowUp",
  "ArrowDown",
  "PageUp",
  "PageDown",
]);

// Returns the event handlers a typed-only numeric field needs. Pass a field's
// own key handler as `onKeyDown` and it still runs for every key that is not a
// stepping key, which keeps the Enter-to-submit behavior on the final estimate.
export function typedNumberInputProps({ onKeyDown } = {}) {
  return {
    onWheel: (event) => {
      // Dropping focus is what actually stops the browser from applying the
      // wheel delta; preventDefault on a passive wheel listener does not.
      if (event.currentTarget === document.activeElement) {
        event.currentTarget.blur();
      }
    },
    onKeyDown: (event) => {
      if (STEPPING_KEYS.has(event.key)) {
        event.preventDefault();
        return;
      }
      if (typeof onKeyDown === "function") {
        onKeyDown(event);
      }
    },
  };
}
